import { useEffect, useState } from "react";
import ShareDialog from "@/pages/detail/components/ShareDialog";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  videoId: string;
  title: string;
}

export default function DetailActions({ videoId, title }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [shareOpen, setShareOpen] = useState(false);
  const [toast, setToast] = useState("");

  const saved = isFavorite(videoId);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleFavorite = () => {
    toggleFavorite(videoId);
    setToast(saved ? "已取消收藏" : "已加入收藏，保存在本机浏览器");
  };

  return (
    <div className="mt-6 flex flex-wrap items-center gap-2.5">
      <button
        type="button"
        onClick={handleFavorite}
        aria-pressed={saved}
        className={`flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-5 text-sm font-bold transition-colors ${
          saved
            ? "bg-primary-700 text-accent-300 hover:bg-primary-600"
            : "bg-accent-500 text-foreground-950 hover:bg-accent-400"
        }`}
      >
        <i className={`${saved ? "ri-bookmark-fill" : "ri-bookmark-line"} text-base`} />
        {saved ? "已收藏" : "收藏"}
      </button>

      <button
        type="button"
        onClick={() => setShareOpen(true)}
        className="flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 text-sm font-medium text-background-100 transition-colors hover:border-background-50/60 hover:bg-background-50/10"
      >
        <i className="ri-share-forward-line text-base" />
        分享
      </button>

      <span className="flex items-center gap-1.5 text-[11px] text-background-400">
        <i className="ri-database-2-line text-sm" />
        收藏状态仅保存在本机浏览器
      </span>

      <ShareDialog open={shareOpen} onClose={() => setShareOpen(false)} title={title} />

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[90] -translate-x-1/2 rounded-md bg-primary-950 px-4 py-2.5 text-xs font-medium text-background-50">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400" />
            {toast}
          </span>
        </div>
      )}
    </div>
  );
}